<template>
  <card header-classes="bg-transparent">
    <b-row align-v="center" slot="header">
      <b-col>
        <h6 class="text-uppercase ls-1 mb-1">Monthly</h6>
        <h5 class="h3 mb-0">Gross Commission Income</h5>
      </b-col>
      <b-col class="text-right">
        <b-badge variant="danger" pill class="mr-3">
          Goal GCI: ${{ goalProfit.toLocaleString() }}
        </b-badge>
        <b-badge variant="primary" pill>
          Actual GCI: ${{ totalProfit.toLocaleString() }}
        </b-badge>
      </b-col>
    </b-row>
    <div class="chart" style="margin-top:60px;" v-if="chartData && profitGoals">
      <line-chart
        :height="350"
        :chart-data="chartData"
        :extra-options="extraOptions"
      >
      </line-chart>
    </div>
  </card>
</template>

<script>
import LineChart from '@/components/Charts/LineChart';
import * as chartConfigs from '@/components/Charts/config';
import { Charts } from "@/components/Charts/config";

export default {
  props: {
    monthlyProfits: null,
    profitGoals: null
  },
  components: {
    LineChart
  },
  data() {
    return {
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      chartData: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [{
          label: 'Actual',
          data: []
        },
        {
          label: 'Goal',
          data: []
        }]
      },
      extraOptions: {
        scales: {
          yAxes: [{
            ticks: {
              maxTicksLimit: 10,
              callback: function(value, index, ticks) {
                  return '$' + value.toLocaleString();
              }
            },
            gridLines: {
              display: false
            },
          }],
          xAxes: [{
            beginAtZero: true,
            ticks: {
              autoSkip: false
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var dataLabel = data.datasets[tooltipItem.datasetIndex].label;
              var value = ': $' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});

              if (Chart.helpers.isArray(dataLabel)) {
                dataLabel = dataLabel.slice();
                dataLabel[0] += value;
              } else {
                dataLabel += value;
              }

              return dataLabel;
            }
          }
        },
      }
    }
  },
  computed: {
    totalProfit() {
     return this.monthlyProfits.reduce((total, a) => total + a, 0);
    },
    goalProfit() {
      return this.profitGoals.reduce((total, a) => total + a, 0);
    }
  },
  watch: {
    monthlyProfits(to, from) {
      this.chartData = {
        labels: this.months,
        datasets: [{
          label: 'Actual',
          data: to,
          borderWidth: 2,
          borderColor: '#006acc',
          pointStyle: 'circle',
          pointBackgroundColor: '#006acc',
          pointRadius: 3
        },
        {
          label: 'Goal',
          data: this.profitGoals,
          borderWidth: 2,
          borderColor: '#dc3545',
          pointStyle: 'circle',
          pointBackgroundColor: '#dc3545',
          pointRadius: 3
        }]
      };
    }
  }
};
</script>